'use client';

import { Radio, RadioGroup as RG } from '@headlessui/react';
import { Icon } from './Icon';
import { clsx } from 'clsx';

export const RadioGroup = ({ label, groups, value, onChange }: any) => {
  return (
    <fieldset>
      <legend className="text-base/6 text-slate-800 font-semibold mb-2">{label}</legend>
      <RG
        value={value}
        onChange={(val: any) => {
          if (!val.isDisabled) onChange(val);
        }}
        className="grid grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-4"
      >
        {groups.map((group: any) => {
          const disabled = group.isDisabled;
          return (
            <Radio
              key={group.id}
              value={group}
              disabled={disabled}
              aria-label={group.title}
              className={`group bg-white relative flex rounded-lg border border-slate-200 py-4 px-4 shadow-sm focus:outline-none
                data-[focus]:border-blue-600 data-[focus]:ring-2 data-[focus]:ring-blue-600
                ${disabled ? 'cursor-not-allowed bg-slate-100' : 'cursor-pointer'}`}
            >
 
              <div className="flex flex-1 items-center">
                <span className={clsx(disabled ? 'text-slate-400' : 'text-slate-700', 'block text-sm font-medium')}>{group.title}</span>
              </div>

              <span
                aria-hidden="true"
                className="text-blue-600 group-[&:not([data-checked])]:invisible"
              >
                <Icon prefix="fas" icon="circle-check" />
              </span>

              <span
                aria-hidden="true"
                className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent group-data-[focus]:border group-data-[checked]:border-blue-600"
              />
            </Radio>
          );
        })}
      </RG>
    </fieldset>
  );
};
